import * as yup from 'yup';
import * as utils from './utils';
import { HistoriqueLogs } from '../entities';

export const schemaHistoriqueLogs = yup.object<Partial<HistoriqueLogs>>({
    name: yup.string().required('Ce champ est requis'),
    nom_table: yup.string().required('Ce champ est requis'),
    id_element: yup.number().required('Le id associé est obligatoire'),
    nom_usager: yup.string().required('Ce champ est requis'),
    nom_element: yup.string(),
    date_modification: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
}) as yup.ObjectSchema<Partial<HistoriqueLogs>>;
